import React, { forwardRef } from 'react';

import type { MasksNullableParameter } from '@vlabs/api/luna-api/model';
import { MASK_OPTIONS } from '@vlabs/api-bindings/src/constants';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function MaskFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedMasks = filters.masks ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedMasks.length === 0}
      onClickReset={() => updateFilters({ masks: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isSearchable={false}
        name="masks"
        onChange={(value) => updateFilters({
          masks: value.length > 0 ? (value as unknown as MasksNullableParameter) : undefined,
        })}
        options={MASK_OPTIONS.raw}
        value={selectedMasks as unknown as string[]}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const MaskFilterPopoverWithRef = forwardRef(MaskFilterPopover);
export { MaskFilterPopoverWithRef as MaskFilterPopover };
